/**
 * WhatsApp Payment Method Highlight
 * Owner: Pavit Gogia
 * Expiry: 2026-11-11
 * Cleanup: https://github.com/Borradh-Media/borradh-workspace/issues/1524
 * Default off. Gates only the payment-blocker highlight on the homepage.
 */
export const WHATSAPP_PAYMENT_METHOD_HIGHLIGHT_FLAG =
  'rollout-whatsapp-payment-method-highlight';

/**
 * Meta connect selection dialog
 * Owner: Daniel Cerasi
 * Expiry: 2026-11-16
 * Default off. Off: connecting Meta attaches every usable ad account and every
 * Page the Facebook login reaches, with no dialog. On: the owner picks them in
 * the selection dialog (skipped when there is only one of each).
 */
export const META_CONNECT_SELECTION_DIALOG_FLAG =
  'rollout-meta-connect-selection-dialog';
